// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2K-gr","author":"Table_author__3oIhN","authorImage":"Table_authorImage__3uwpq","unreadRow":"Table_unreadRow__2q71-"};